import React from 'react';


export default class Instruction extends React.Component{

    render(){
        return(<div>Hello</div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/citizen/User/Instruction/index.js